import React, { Component, ReactNode } from "react";
import { createPortal } from "react-dom";
import {
  ExitIcon,
  ModalBG,
  ModalContainer,
  Title,
  Content,
  Footer
} from "./styles";

const modalRoot = document.getElementById("modal-root");

interface PopupModalProps {
  footer?: ReactNode;
  onClose: () => void;
  title?: ReactNode;
}

export default class PopupModal extends Component<PopupModalProps> {
  el = document.createElement("div");

  componentDidMount() {
    if (!modalRoot) return console.warn("can not find #modal-root");
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    if (modalRoot) modalRoot.removeChild(this.el);
  }

  render() {
    const { children, footer, onClose, title } = this.props;

    return createPortal(
      <ModalBG onClick={onClose}>
        <ModalContainer onClick={e => e.stopPropagation()} hasFooter={!!footer}>
          <ExitIcon onClick={onClose} />
          {title && <Title>{title}</Title>}
          <Content>{children}</Content>
          {footer && <Footer>{footer}</Footer>}
        </ModalContainer>
      </ModalBG>,
      this.el
    );
  }
}
